import { useState } from 'react';
import { AppContext } from './AppContext';

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
    const [successfulMessage, setSuccessfulMessage] = useState<string | undefined>(undefined);

    return (
        <AppContext.Provider value={{
            successfulMessage,
            setSuccessfulMessage,
        }}
        >
            {children}
        </AppContext.Provider>
    );
};
